/**
 * @generated SignedSource<<10ddff6bcdc11d9b404feb825b0097c3>>
 * 
 * @lightSyntaxTransform
 *//* eslint-disable */'use strict';/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternalDeleteAppAsset$variables = {|
  candidateId: string,
|};
export type InternalDeleteAppAsset$data = {|
  +internalDeleteAppAsset: boolean,
|};
export type InternalDeleteAppAsset = {|
  response: InternalDeleteAppAsset$data,
  variables: InternalDeleteAppAsset$variables,
|};
*/var node/*: ConcreteRequest*/=function(){var v0=[{"defaultValue":null,"kind":"LocalArgument","name":"candidateId"}],v1=[{"alias":null,"args":[{"kind":"Variable","name":"candidateId","variableName":"candidateId"}],"kind":"ScalarField","name":"internalDeleteAppAsset","storageKey":null}];return{"fragment":{"argumentDefinitions":v0/*:: as any*/,"kind":"Fragment","metadata":null,"name":"InternalDeleteAppAsset","selections":v1/*:: as any*/,"type":"Mutation","abstractKey":null},"kind":"Request","operation":{"argumentDefinitions":v0/*:: as any*/,"kind":"Operation","name":"InternalDeleteAppAsset","selections":v1/*:: as any*/},"params":{"cacheID":"78d81ca271414fc226600e61e4886224","id":null,"metadata":{},"name":"InternalDeleteAppAsset","operationKind":"mutation","text":"mutation InternalDeleteAppAsset(\n  $candidateId: UUID!\n) {\n  internalDeleteAppAsset(candidateId: $candidateId)\n}\n"}};}();node/*:: as any*/.hash="53a18c9a46e216de07112bec2dcdac21";export default node/*:: as any*//*:: as Mutation<
  InternalDeleteAppAsset$variables,
  InternalDeleteAppAsset$data,
>*/;